import React, {useState, ChangeEvent, useEffect} from "react";
import {Select2, Select2UpdateValue} from "select2-react-component";
import InputComponent from "../../../../shared/ui/common/InputComponent";
import {isEmpty} from "underscore";

const enum Actions {
    ONLOAD_JS = "onloadJs",
    CUSTOM_JS = "customJs",
}

interface OnLoadActionModel {
    type?: Actions.ONLOAD_JS;
    actionId?: string;
    code?: string;
    parameters?: {[key: string]: string};
    name: string;
}

interface OnloadActionCollection {
    label: string;
    value: string;
    model?: OnLoadActionModel;
}

interface OnLoadActionParameters {
    paramLabel: string;
    paramValue: string;
}

interface OnLoadActionProps {
    onChange: (value: OnloadActionCollection) => Array<OnLoadActionParameters>;
    parameters: {[key: string]: string};
    name: string;
    params: Array<OnLoadActionParameters>;
}

let onloadActions: OnloadActionCollection[] = [];
const LoggedInUserState = require("shared/ui/user/LoggedInUserState"),
      Configuration = require("shared/services/Configuration"),
      Storage       = require("shared/services/Storage");

export default function OnLoadAction(props: OnLoadActionProps) {
    
    const [params, setParams] = useState(props.params || []);
    // If permissionFlag is false we don't render OnLoadAction component
    const [permissionFlag, setPermissionFlag] = useState(false);

    const getOnloadSettings = () => {
        const companyId = LoggedInUserState.attributes.company.id,
            settingName = 'onloadActionEnabled',
            endpointUrl = `${Configuration.creatorSettingApiBaseUrl}/v1/settings/${companyId}?name=${settingName}`,
            token = Storage.Local.get(Storage.Keys.LOGIN, "token") || Storage.Session.get(Storage.Keys.LOGIN, "token"),
            bearerToken = `Bearer ${token}`;

        const options = {
            method: "GET",
            headers: {
                "Authorization": bearerToken
            }
        }
            
        fetch(endpointUrl, options)
            .then(res => res.json())
            .then(data => {
                Storage.Local.update(Storage.Keys.ONLOAD_ACTION_ENABLED, data);
                if(data.onloadActionEnabled) setPermissionFlag(data.onloadActionEnabled);
            })
            .catch(err => console.log(err));
    }

    const isActionEnabled = () => {
        let initialLoadCount = Storage.Local.get(Storage.Keys.ONLOAD_ACTION_ENABLED, Storage.Keys.ONLOAD_COMPONENT_INIT_COUNT) || 0;
        Storage.Local.update(Storage.Keys.ONLOAD_ACTION_ENABLED, Storage.Keys.ONLOAD_COMPONENT_INIT_COUNT, ++initialLoadCount);
        if(initialLoadCount <= 1) {
            getOnloadSettings();
        }
        else {
            const isEnabled = Storage.Local.get(Storage.Keys.ONLOAD_ACTION_ENABLED, "onloadActionEnabled");
            setPermissionFlag(isEnabled);
        }
    }

    useEffect(isActionEnabled, [permissionFlag]);

    // Retrieve all the customJs action
    const getOnLoadActions = (): OnloadActionCollection[] => {

        let protoType = LoggedInUserState.get("prototypeActionCollection").filter((prototype) => prototype.get("action").get("type") === Actions.CUSTOM_JS);

        // onloadActions.length - 1 = Remove the default option and then compare with protoType.length
        if (protoType.length === onloadActions.length - 1) {
            return onloadActions;
        }

        onloadActions = [];

        // Default Option
        onloadActions.push({
            label: 'None', 
            value: 'None',
            model: {name: ''},
        });

        // Take all the actions from prototype and push into onloadActions[]
        protoType.forEach((obj) => {
                const attr = obj.attributes.action.attributes;
                onloadActions.push({
                    label: attr.name,
                    value: attr.name,
                    model: {
                        type: Actions.ONLOAD_JS,
                        actionId: attr.actionId,
                        code: attr.code,
                        parameters: attr.parameters,
                        name: attr.name,
                    },
                });
        });

        return onloadActions;
    };

    // Triggers when selection in dropdown changes
    const handleActionChange = (value: Select2UpdateValue) => {
        let currentAction: OnloadActionCollection = onloadActions.find((opt) => opt.label === value);
        // Sync state with props - onChange method return Array<OnLoadActionParameters>
        setParams(props.onChange(currentAction));
    };

    // Triggers when input field loses focus
    const handleParamInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        let currentAction: OnloadActionCollection = onloadActions.find((act) => act.model.name === props.name);
        currentAction.model.parameters = params.reduce((obj, item) => ((obj[item.paramLabel] = item.paramValue), obj), {});
        // Sync state with props - onChange method return Array<OnLoadActionParameters>
        setParams(props.onChange(currentAction));
    };

    // Triggers when there is a change in input field (keyup, keydown event)
    const updateParamState = (e: ChangeEvent<HTMLInputElement>, index: number) => {
        e.preventDefault();
        const label = e.target.placeholder;
        const value = e.target.value;
        setParams((params: Array<OnLoadActionParameters>) => {
            let temp = [...params];
            temp[index] = {paramLabel: label, paramValue: value};
            return temp;
        });
    };

    const onloadActionsOptions = (): OnloadActionCollection[] => {
        const actions = getOnLoadActions();
        return actions.map((el) => ({label: el.label, value: el.value}));
    };

    const styleClasses = {
        sectionHeading: "onload-label",
        inputDefault: "onload-input full-width",
        mainContainer: "onload-section",
        inputContainer: "zmags-input-control"
    };

    return (
        permissionFlag ?
        ( <div className={styleClasses.mainContainer}>
            <div className={styleClasses.inputContainer}>
                <label className={styleClasses.sectionHeading}>On load Action Type: </label>
                <Select2
                    placeholder="None"
                    value={props.name}
                    data={onloadActionsOptions()}
                    update={(value: Select2UpdateValue) => handleActionChange(value)}
                />

                <div style={{marginTop: "0.7rem"}}></div>

                {!isEmpty(props.parameters) &&
                    params.map((_, index: number) => (
                        <InputComponent
                            classNames={styleClasses.inputDefault}
                            type="text"
                            value={params[index].paramValue}
                            placeholder={params[index].paramLabel}
                            onChange={(e: ChangeEvent<HTMLInputElement>) => updateParamState(e, index)}
                            onBlur={(e: ChangeEvent<HTMLInputElement>) => handleParamInputChange(e)}
                            key={index}
                        />
                    ))}
            </div>
        </div>): <></>
    );
}


// WEBPACK FOOTER //
// ./src/editor/ui/experience/action/OnLoadAction.tsx